import { Button, Modal } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';
import HTML_MAIL_RECU_DEFAUT from '@/assets/text/htmlMailRecuDefaut';
import { EditeurMail } from '@/components/EditeurMail';
import { RECU_MAIL_ELEMENTS_DISPONIBLES } from '@/constants';

type ModalMailRecuProps = {
  htmlMailRecu?: string;
  loading?: boolean;
  onClose: () => void;
  onSave?: (html: string) => void;
};

const ModalMailRecu = (props: ModalMailRecuProps) => {
  const { htmlMailRecu, loading = false, onClose, onSave } = props;

  const initialHtml = _.isEmpty(htmlMailRecu) ? HTML_MAIL_RECU_DEFAUT : htmlMailRecu;

  const [html, setHtml] = React.useState<string>(initialHtml);
  const [modifie, setModifie] = React.useState<boolean>(false);

  const handleEditeurChange = React.useCallback((value: string, isModifie: boolean) => {
    setHtml(value);
    setModifie(isModifie);
  }, []);

  const handleEnregistrer = React.useCallback(() => {
    onSave?.(html);
  }, [html, onSave]);

  return (
    <Modal open size="large" onClose={onClose} closeIcon={!loading}>
      <Modal.Header>Personnalisation du mail de reçu</Modal.Header>
      <Modal.Content scrolling={false}>
        <EditeurMail
          htmlDefaut={HTML_MAIL_RECU_DEFAUT}
          htmlInitial={initialHtml}
          elements={RECU_MAIL_ELEMENTS_DISPONIBLES}
          loading={loading}
          onChange={handleEditeurChange}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="button-annuler"
          onClick={onClose}
          basic
          size="tiny"
          icon="close"
          content="Annuler"
          disabled={loading}
        />
        <Button
          data-testid="button-enregistrer"
          positive
          onClick={handleEnregistrer}
          content="Enregistrer"
          icon="save"
          disabled={!modifie || loading}
          loading={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalMailRecu;
